// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createAdminVendorApiKeyRequests = (client) => ({
    /**
     * `POST /admin/vendor-api-key-requests/:id/approve`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminApproveVendorApiKeyRequest
     * @source apps/backend/src/api/admin/vendor-api-key-requests/[id]/approve/route.ts
     */
    approve: (id, body, query, headers) => client.fetch(buildPath("/admin/vendor-api-key-requests/:id/approve", [id]), { method: "POST", body, query, headers }),
    /**
     * `GET /admin/vendor-api-key-requests`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminListVendorApiKeyRequests
     * @source apps/backend/src/api/admin/vendor-api-key-requests/route.ts
     */
    list: (query, headers) => client.fetch("/admin/vendor-api-key-requests", { method: "GET", query, headers }),
    /**
     * `POST /admin/vendor-api-key-requests/:id/reject`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminRejectVendorApiKeyRequest
     * @source apps/backend/src/api/admin/vendor-api-key-requests/[id]/reject/route.ts
     */
    reject: (id, body, query, headers) => client.fetch(buildPath("/admin/vendor-api-key-requests/:id/reject", [id]), { method: "POST", body, query, headers }),
});
//# sourceMappingURL=vendor-api-key-requests.js.map